













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { NumberRule } from "@root/lib/common";
@Component({})
export default class EditPriceDialog extends Vue {
  @Prop({ default: "" }) price;
  ruleForm = {
    price: ""
  };
  rules = {};
  NumberRule: any = null;
  isVisible = false;
  @Watch("price", { immediate: true })
  watchPrice(val) {
    this.ruleForm.price = val;
  }
  created() {
    this.NumberRule = NumberRule.bind(this);
  }
  confirmPrice() {
    (this.$refs.ruleForm as any).validate(valid => {
      if (valid) {
        this.$emit("changePrice", this.ruleForm.price);
        let $priceDialog = this.$refs.pricePop;
        ($priceDialog as any).doClose();
      }
    });
  }
  cancel() {
    let $priceDialog = this.$refs.pricePop;
    ($priceDialog as any).doClose();
  }
  hideIconActive() {
    this.isVisible = false;
  }
  showIconActive() {
    this.isVisible = true;
  }
}
